<template>
  <div class="trade-tabs-widget">
    <div
      v-for="button in buttons"
      :key="button.value"
      size="xs"
      class="trade-tabs-widget__button pt-4 pb-4 pl-16 pr-16 mr-8"
      :class="{
        'trade-tabs-widget__button--active': button.value === value.value,
      }"
      @click="changeTab(button)"
    >
      <span
        class="trade-tabs-widget__button-text txt txt--12px txt--height--16px txt--bold"
        v-text="button.label"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'TradeTabsWidget',

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    buttons: {
      type: Array,
      default: () => [],
    },
  },

  methods: {
    changeTab (currentTab) {
      this.$emit('input', currentTab)
    },
  },
}
</script>

<style lang="scss" scoped>
.trade-tabs-widget {
  display: flex;
  position: relative;
  z-index: 1;
  padding: 0 0 0 5px;

  &__button {
    color: color('color-03');
    border: 1px solid color('transp-02');
    border-radius: toRem(30px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    &--active {
      background: color('main');
      color: color('color-01');
      border-color: color('main');
    }
  }

  &__button-text {
    position: relative;
    z-index: 2;
    color: currentColor;
  }
}
</style>
